import { CosmosDb } from '../cosmosDb.js';

export namespace ExerciseDb {
	export const difficultyLevels = ['Beginner', 'Novice', 'Intermediate', 'Advanced', 'Expert'] as const;
	export const equipment = [
		'Ab Wheel',
		'Barbell',
		'Battle Ropes',
		'Bodyweight',
		'Bulgarian Bag',
		'Cable',
		'Clubbell',
		'Dumbbell',
		'Slam Ball',
		'EZ Bar',
		'Gymnastic Rings',
		'Indian Club',
		'Kettlebell',
		'Landmine',
		'Macebell',
		'Medicine Ball',
		'Resistance Band',
		'Miniband',
		'Parallette Bars',
		'Sled',
		'Pull Up Bar',
		'Sandbag',
		'Suspension Trainer',
		'Sliders',
		'Stability Ball',
		'Superband',
		'Tire',
		'Trap Bar',
		'Wall Ball',
		'Weight Plate'
	] as const;
	export const forceType = ['Other', 'Push', 'Pull', 'Push & Pull'] as const;
	export const laterality = ['Unilateral', 'Bilateral', 'Contralateral', 'Ipsilateral'] as const;
	export const exerciseSource = ['everkinetic', 'custom', 'strength-to-overcome'] as const;
	export const targetMuscleGroup = [
		'Abdominals',
		'Abductors',
		'Back',
		'Biceps',
		'Calves',
		'Chest',
		'Forearms',
		'Glutes',
		'Hamstrings',
		'Quadriceps',
		'Hip Flexors',
		'Shins',
		'Shoulders',
		'Trapezius',
		'Triceps'
	] as const;

	export type Equipment = (typeof equipment)[number];
	export type DifficultyLevel = (typeof difficultyLevels)[number];
	export type ForceType = (typeof forceType)[number];
	export type Laterality = (typeof laterality)[number];
	export type TargetMuscleGroup = (typeof targetMuscleGroup)[number];
	export type ExerciseSource = (typeof exerciseSource)[number];

	export interface IExerciseItem extends CosmosDb.ItemDefaultOmit<IBaseExerciseItem>, CosmosDb.ICosmosItem {}

	export interface IBaseExerciseItem extends CosmosDb.IBaseItem {
		readonly targetMuscleGroup?: TargetMuscleGroup;
		readonly tagline?: string;
		readonly source: ExerciseSource;
		readonly instructions?: string;
		readonly videoUrl?: string;
		readonly equipment?: Equipment;
		readonly difficulty?: DifficultyLevel;
		readonly forceType?: ForceType;
		readonly laterality?: Laterality;
		readonly categories?: string[];
		images?: CosmosDb.ICosmosFileReference[];
	}

	export interface IExerciseIdProps {}
}
